// 在线字典
import request from "@/services/axios";
import { url } from "@/services/api";

export default {
  // 分页列表查询
  getPrintModelList(data) {
    return request({
      url: url + "admin/upms/printModel/list",
      method: "post",
      data: data
    });
  },

  // 标签模板详情
  getPrintModelInfo(params) {
    return request({
      url: url + "admin/upms/printModel/view",
      method: "get",
      params
    });
  },

  // 新增标签模板
  AddPrintModel(data) {
    return request({
      url: url + "admin/upms/printModel/add",
      method: "post",
      data: data
    });
  },
  // 修改标签模板
  UpdatePrintModel(data) {
    return request({
      url: url + "admin/upms/printModel/update",
      method: "post",
      data: data
    });
  },
  // 修改标签模板
  DelPrintModel(params) {
    return request({
      url: url + "admin/upms/printModel/delete",
      method: "post",
      params
    });
  }
};
